import { render } from "./TermsOfUse.vue?vue&type=template&id=6604a7a7"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"
script.render = render

export default script